import { useMemo } from "react";
export const usePagination = ({
    totalCount,
    pageSize,
    siblingCount = 1,
    currentPage
}) => {
    const paginationRange = useMemo(() => {
        // Force fixed 4 pages
        const fixedPageCount = 4;

        // Generate array [1, 2, 3, 4]
        return Array.from({ length: fixedPageCount }, (_, idx) => idx + 1);
    }, [currentPage]);

    return paginationRange;
};